import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { buildSteps, corePageTypes } from '../../data/websites';
export function ThreeDayBuild() {
  return <section aria-labelledby="built-in-3-days" className="bg-white px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1025" data-mp="1nnc4d14gncef">
      <div className="grid gap-12 lg:grid-cols-12 xl:gap-20" data-id="element-1026" data-mp="19rzxjvd15vh5">
        <div className="lg:col-span-7" data-id="element-1027" data-mp="1enfdqtyig3gq">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1028" data-mp="zzu8oui2ru66">Built in 3 days</p>
          <h2 id="built-in-3-days" className="mt-3 text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-1029" data-mp="14qke27qi3x0v">
            Why 3 days is possible.
          </h2>
          <p className="mt-5 max-w-[60ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-1030" data-mp="uzzkiypopiot">
            We build the core of your website in 3 days. Most websites are built from 5 to 10 main page types. We build
            that core first. After that, new pages take hours, not weeks.
          </p>
          <ul className="mt-6 flex flex-wrap gap-2" aria-label="Core page types" data-id="element-1031" data-mp="1miqbe38mslrx">
            {corePageTypes.map(page => <li key={page} className="rounded-full bg-brand-light px-4 py-2 text-sm font-semibold text-brand-black" data-id="element-1032" data-mp="1hn2ltmq8lqlw">
                {page}
              </li>)}
          </ul>
        </div>

        <aside aria-labelledby="real-people" className="self-end border-t-4 border-brand-red bg-gray-50 p-8 lg:col-span-5 xl:p-10" data-id="element-1033" data-mp="1qjto4gvdu1ox">
          <MapPinIcon className="h-7 w-7 text-brand-red" aria-hidden="true" data-id="element-1034" data-mp="yv07wj4zcofc" />
          <h2 id="real-people" className="mt-4 text-[clamp(1.5rem,2vw,2.25rem)] font-extrabold leading-tight text-brand-black" data-id="element-1035" data-mp="1clvbph0mgfc2">
            Real people in Las Vegas.
          </h2>
          <p className="mt-3 text-lg font-semibold text-brand-black" data-id="element-1036" data-mp="17t26yt55l6zz">Real people. Real hours. Right here in the U.S.</p>
          <p className="mt-3 leading-relaxed text-gray-600" data-id="element-1037" data-mp="f6hic0g2b904">
            When you talk to our team, you talk to people in Las Vegas during normal business hours.
          </p>
        </aside>
      </div>

      <ol className="mt-16 grid gap-px overflow-hidden rounded-xl border border-gray-200 bg-gray-200 md:grid-cols-3" data-id="element-1038" data-mp="2k7k49c2myuh4">
        {buildSteps.map((step, i) => <li key={step.title} className="bg-white p-8 xl:p-10" data-id="element-1039" data-mp="2ozbwrs5cra9w" data-mpi={i}>
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-red text-lg font-extrabold text-white" data-id="element-1040" data-mp="2twljh01cx7u1">
              {i + 1}
            </span>
            <h3 className="mt-5 text-[clamp(1.25rem,1.5vw,1.75rem)] font-bold text-brand-black" data-id="element-1041" data-mp="218pn5wfp9hxs">{step.title}</h3>
            <p className="mt-2 text-[clamp(1rem,1.05vw,1.1875rem)] leading-relaxed text-gray-600" data-id="element-1042" data-mp="267sw3rysw8b1">{step.body}</p>
          </li>)}
      </ol>
    </section>;
}